import styled from '@emotion/styled'

import pickYourRecipesBg from './assets/pick_your_recipes_bg.png'

type ExplanationBoxContentProps = {
  bgColor: string
  isPickYourRecipes: boolean
}
export const ExplanationBoxContent = styled.div(
  ({ bgColor, isPickYourRecipes }: ExplanationBoxContentProps) => ({
    padding: '1rem',
    minWidth: '100%',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    position: 'relative',
    zIndex: 2,
    backgroundColor: 'white',

    ...(isPickYourRecipes
      ? {
          backgroundColor: bgColor,
        }
      : {}),
    ...(isPickYourRecipes
      ? {
          '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'block',
            content: '""',
            backgroundImage: `url(${pickYourRecipesBg})`,
            zIndex: 0,
            width: '100%',
            height: '100%',
            opacity: 0.2,
          },
        }
      : {}),
  }),
)

type ConnectionLineProps = {
  directionLeft: boolean
  color: string
}
export const ConnectionLine = styled.div(({ directionLeft, color }: ConnectionLineProps) => {
  const border = `1px dashed ${color}`

  return {
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    borderTop: border,
    width: '100px',
    height: '100px',
    borderRadius: '50px',

    ...(directionLeft
      ? { left: 0, transform: 'translateX(-50%)', borderLeft: border }
      : { right: 0, transform: 'translateX(50%)', borderRight: border }),

    '@media (min-width: 320px) and (max-width: 374px)': {
      display: 'none',
    },

    '@media (min-width: 375px) and (max-width: 639px)': {
      width: '120px',
      height: '120px',
      borderRadius: '80px',
    },
  }
})

export const ExplainTheWizardContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '12px',
  alignSelf: 'center',
  width: '100%',

  '@media (max-width: 375px)': {
    width: '100%',
  },

  '@media (min-width: 376px) and (max-width: 639px)': {
    width: '375px',
  },

  '@media (min-width: 960px)': {
    width: '80%',
  },
})
